import React from 'react'
import PropTypes from 'prop-types'
import uniq from 'lodash/uniq'
import flatMapDeep from 'lodash/flatMapDeep'
import values from 'lodash/values'

const FormErrors = ({errors}) => {
  const renderErrors = () => {
    return uniq(flatMapDeep(values(errors))).map((error, i) => {
      return <span key={i}>{error}</span>
    })
  }

  return errors && <div className="errors-container">{renderErrors()}</div>
}

FormErrors.propTypes = {
  errors: PropTypes.object.isRequired
}

export default FormErrors
